import { SYS_SPACE_FIXED_250 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const SelectionStepBlock = styled.div`
	display: flex;
	flex-direction: column;
	fieldset {
		margin-top: ${SYS_SPACE_FIXED_250};
	}
`;
